import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { API_URL, TOKEN } from "../../../variables/constants";
import { toast } from "react-toastify";

const AddTypeProfil = ({
  show,
  handleClose,
  editMode,
  selectedTypeProfil,
  typeProfils,
  onSaveSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [nom, setNom] = useState("");
  const [error, setError] = useState(""); // Pour gérer les erreurs de validation

  useEffect(() => {
    if (editMode && selectedTypeProfil) {
      setNom(selectedTypeProfil.libelleParametre || "");
    } else {
      setNom("");
    }
    setError(""); // Réinitialiser les erreurs lors de l'ouverture/fermeture du modal
  }, [editMode, selectedTypeProfil, show]); // Ajouter 'show' comme dépendance pour réinitialiser l'erreur

  const onSubmit = (e) => {
    e.preventDefault();
    setError(""); // Réinitialiser l'erreur à chaque soumission

    // 5. Validation du champ de nom: ne doit pas être vide ou contenir uniquement des espaces
    if (!nom.trim()) {
      setError(
        "Le nom ne peut pas être vide ou contenir uniquement des espaces."
      );
      return;
    }

    // 2. Blocage des doublons (insensible à la casse)
    const normalizedNewName = nom.trim().toLowerCase();
    const isDuplicate = typeProfils.some(
      (tp) =>
        tp.libelleParametre.toLowerCase() === normalizedNewName &&
        (!editMode || tp.parametreId !== selectedTypeProfil?.parametreId) // Permet la modification du même élément sans déclencher de doublon
    );

    if (isDuplicate) {
      setError("Un type de profil avec ce nom existe déjà.");
      return;
    }

    setLoading(true);

    const typeProfilData = {
      ...selectedTypeProfil, // Garde l'ID et autres champs pour la modification
      libelleParametre: nom.trim(), // Assurez-vous de trimmer le nom avant l'envoi
      typeParametre: "TYPE_PROFIL",
    };

    const request = editMode
      ? axios.put(`${API_URL}/api/parametre`, typeProfilData, {
          headers: {
            Authorization: `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        })
      : axios.post(`${API_URL}/api/parametre`, typeProfilData, {
          headers: {
            Authorization: `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        });

    request
      .then((res) => {
        toast.success(
          editMode
            ? "Type de profil modifié avec succès"
            : "Type de profil ajouté avec succès"
        );
        onSaveSuccess(res.data); // Passez les données de l'élément enregistré au parent
        // handleClose(); // Sera appelé par onSaveSuccess dans le parent pour fermer le modal
      })
      .catch((err) => {
        console.error("Error saving type profil:", err);
        // Vous pouvez analyser l'erreur du backend si le message est spécifique
        toast.error(
          "Erreur lors de l'enregistrement du type de profil. Veuillez réessayer."
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Body>
        <button
          type="button"
          className="btn-close btn-primary"
          onClick={handleClose}
          aria-label="Close"
        ></button>
        <div className="text-center mb-6">
          <h4>{editMode ? "Modifier le" : "Ajouter un"} type de profil</h4>
          <p>
            {editMode ? "Modifier le" : "Ajouter un nouveau"} type de profil
          </p>
        </div>
        <form onSubmit={onSubmit}>
          <div className="mb-3">
            <label className="form-label">Nom</label>
            <input
              type="text"
              className={`form-control ${error ? "is-invalid" : ""}`}
              placeholder="Nom du type de profil"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              required 
            />
            {error && <div className="invalid-feedback">{error}</div>}
          </div>
          <div className="text-center">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Enregistrement..." : "Enregistrer"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddTypeProfil;
